import { render, staticRenderFns } from "./inquiryInfoCard.vue?vue&type=template&id=526fa871&scoped=true"
import script from "./inquiryInfoCard.vue?vue&type=script&lang=js"
export * from "./inquiryInfoCard.vue?vue&type=script&lang=js"
import style0 from "./inquiryInfoCard.vue?vue&type=style&index=0&id=526fa871&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526fa871",
  null
  
)

export default component.exports